module.exports = __webpack_public_path__ + "img/content-01.20fc58da.png";